module.exports = __webpack_public_path__ + "static/media/laptop-banner-w3.e3bab545.png";